export default class Accordeon {
    constructor(element) {
        this.element = element;
        this.groups = this.element.querySelectorAll('.accordeon-group');
        this.init();
    }

    init() {
        this.groups.forEach(group => {
            const content = group.querySelector('.accordeon-content');

            group.addEventListener('click', () => {
                const isOpen = group.classList.contains('open');

                this.closeAll();

                if (!isOpen) {
                    this.openGroup(group, content);
                }
            });
        });

        const firstGroup = this.groups[0];

        if (firstGroup) {
            const firstContent = firstGroup.querySelector('.accordeon-content');
            this.openGroup(firstGroup, firstContent);
        }
    }

    closeAll() {
        this.groups.forEach(group => {
            group.classList.remove('open');

            const content = group.querySelector('.accordeon-content');
            if (content) content.style.maxHeight = null;
        });
    }

    openGroup(group, content) {
        group.classList.add('open');

        if (content) {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    }
}